import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  CircularProgress,
  ClickAwayListener,
  Container, Grid, InputAdornment, Stack, Tab, Tabs, TextField, Tooltip, TooltipProps, Typography, styled, tooltipClasses,
} from '@mui/material';
import Page from '../components/Page';
import { AppDispatch, useAppSelector } from '../store';
import { useDispatch } from 'react-redux';
import _ from 'lodash';
import { useNavigate } from 'react-router-dom';
import '@splidejs/react-splide/css';
import { tutorialTabs } from '../utils/utils';
import { Fragment, useEffect, useState } from 'react';
import useWindowSize from '../utils/useWindowSize';
import SearchIcon from '@mui/icons-material/Search';
import { updateSearchText } from '../store/tutorialVideo/tutorialVideoSlice';
import { getTutorialVideos } from '../store/tutorialVideo/api';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { TutorialVideoItem } from '../store/tutorialVideo/api/interface';
import VideoTutorialModel from '../components/modal/VideoTutorialModel';
import useToggle from '../hooks/useToggle';
import { getAffiliateLandingPageVideos } from '../store/affiliateLandingPageVideo/api';



const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#ffffff',
    color: 'rgba(0, 0, 0, 0.87)',

    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
}));

const VideoTutorial = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const searchText = useAppSelector((state) => state.tutorialVideo.searchText);
  const tutorialVideo = useAppSelector((state) => state.tutorialVideo.data);
  const searchResult = useAppSelector((state) => state.tutorialVideo.searchResult);
  const isLoading = useAppSelector((state) => state.tutorialVideo.isLoading);

  useEffect(() => {
    if (tutorialVideo?.length == 0 && !isLoading) {
      dispatch(getTutorialVideos())
    }
  }, []);

  const {
    toggle: togglenTutorialVideo,
    onOpen: onOpenTutorialVideo,
    onClose: onCloseTutorialVideo,
  } = useToggle();


  const [activeTab, setActiveTab] = useState<number>(0);
  const [openTutorialVideo, setOpenTutorialVideo] = useState<TutorialVideoItem | undefined>(undefined);


  const [tootltipView, setTootltipView] = useState<number | undefined>(undefined);
  const [showAllVideo, setShowAllVideo] = useState<string | undefined>(undefined);

  const windowSize = useWindowSize();
  const [tabMinWidth, setTabMinWidth] = useState(100);
  useEffect(() => {
    const newWidth = windowSize.width / tutorialTabs.length;
    setTabMinWidth(newWidth);
  }, [windowSize]);

  useEffect(() => {

    console.log(tootltipView);

  }, [tootltipView]);

  const inputStyle = {
    borderRadius: 1,
    backgroundColor: '#FFFFFF',
    boxShadow:
      '0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)',
  };

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
    try {
      scrolltoVideo(tutorialTabs[newValue].code);
    } catch (e) { }
  };

  const handleSearchText = (e: any) => {
    dispatch(updateSearchText(e.target.value));
  };

  const scrolltoVideo = (code: string) => {
    try {
      const section = document.querySelector(`#${code}`) as HTMLElement;
      if (section) {
        const headerHeight = (document.getElementById('header') as any).offsetHeight || 0;
        console.log((section?.offsetTop ?? 0) - headerHeight - (headerHeight * 0.10));
        window.scrollTo({
          top: (section?.offsetTop ?? 0) - headerHeight - (headerHeight * 0.10),
          behavior: 'smooth',
        });
      }
    } catch (e) { }
  };


  useEffect(() => {
    if (openTutorialVideo != undefined) {
      onOpenTutorialVideo();
    }
  }, [openTutorialVideo]);

  useEffect(() => {
    if (!togglenTutorialVideo) {
      setOpenTutorialVideo(undefined);
    }
  }, [togglenTutorialVideo]);

  return (
    <>
      <Page
        title='How To | KnoCard'
        showAppBar={true}
        sx={{ backgroundColor: "#002f41", minHeight: '100vh' }}
      >
        <Container maxWidth='xl' sx={{ mt: 2, backgroundColor: "#002f41", width: "100% !important", maxWidth: "none !important", marginLeft: "0px !important", marginRight: "0px !important" }}>
          <Tabs value={activeTab} onChange={handleTabChange} variant="fullWidth"  >
            {tutorialTabs.map((item, idx) => {
              return (<Tab label={item.title} key={`tutorial-tabs-${idx}`} sx={{
                color: "#ffffff",
                textTransform: 'none',
                minWidth: { md: '90px', sm: tabMinWidth, xs: tabMinWidth },
                '&.Mui-selected': {
                  color: '#ffffff', // Set the text color of the active tab
                }
              }} />)
            })}
          </Tabs>
          <Box>
            <TextField
              fullWidth
              autoComplete="off"
              name="search_tutorial_video"
              placeholder='Search Topic'
              value={searchText}
              onChange={handleSearchText}
              InputProps={{
                autoComplete: 'off',
                sx: inputStyle,
                endAdornment: (
                  <InputAdornment position='start'>
                    <SearchIcon sx={{ color: "gray" }} />
                  </InputAdornment>
                ),
              }}
              sx={{ mt: 1 }}
            />
          </Box>

          {searchResult.map((tutorialItem, idx) => {
            return (
              <><Grid key={`tutorialItem-title-${idx}`} container spacing={1}>
                <Grid item id={tutorialItem.code} xs={12} sx={{ position: 'relative', mt: 1, mb: 1 }}>
                  <Typography sx={{ color: "#ffffff", mt: 1, mb: 0.5, fontWeight: 'bold' }}>{tutorialItem.title}</Typography>
                  <Typography sx={{ position: "absolute", right: 0, top: 16, color: "#088AC7" }} onClick={() => (tutorialItem.code != showAllVideo) ? setShowAllVideo(tutorialItem.code) : setShowAllVideo(undefined)} >{(tutorialItem.code == showAllVideo) ? "Show Less" : "Show All"} </Typography>
                </Grid>
              </Grid>
                <Grid container spacing={1}>

                  {((tutorialItem.data.length > 6) ? (tutorialItem.data.slice(0, (tutorialItem.code == showAllVideo) ? tutorialItem.data.length : 4)) : tutorialItem.data).map((tutorialVideo, index) => {
                    return (<Grid item xs={6} md={3} >
                      <Card key={`tutorial-item-${index}`} sx={{ maxWidth: 345 }}>
                        <CardMedia
                          component="img"
                          height="140"
                          image={tutorialVideo.thumb_link}
                          alt={tutorialVideo.thumb_name}
                          onClick={() => setOpenTutorialVideo(tutorialVideo)}
                        />
                        <ClickAwayListener
                          key={`tutorial-item-${idx}-click-away`}
                          onClickAway={() => (tootltipView == tutorialVideo.id) && setTootltipView(undefined)}>
                          <Box component={"div"}>
                            <HtmlTooltip
                              PopperProps={{
                                disablePortal: true,
                              }}
                              disableFocusListener
                              disableHoverListener
                              disableTouchListener
                              open={tootltipView == tutorialVideo.id}
                              onClose={() => setTootltipView(undefined)}
                              title={
                                <Fragment>
                                  <Typography sx={{ color: "#F58227" }}>Description</Typography>
                                  <Typography sx={{ fontSize: "0.8rem", mb: 0.5 }}>{tutorialVideo.description}</Typography>
                                </Fragment>
                              }
                            >
                              <CardActionArea
                                onClick={() => { setTootltipView(tutorialVideo.id) }}
                              >
                                <CardContent
                                  sx={{
                                    p: 0.5, '&:last-child': { p: 1 }, minHeight: '36px',
                                    backgroundColor: "#4fc1e8",
                                    position: 'relative',
                                    display: 'flex',
                                    alignItems: 'center'
                                  }}>
                                  <Typography variant="body2" color="text.secondary"
                                    sx={{
                                      overflow: 'hidden',
                                      display: '-webkit-box',
                                      '-webkit-line-clamp': "1",
                                      '-webkit-box-orient': 'vertical',
                                      color: '#000000',
                                      mr: 2.2
                                    }}>
                                    {tutorialVideo.title}
                                  </Typography>
                                  <ArrowDropDownIcon sx={{ color: "#F58227", position: "absolute", right: 5, top: 5 }} />
                                </CardContent>
                              </CardActionArea>
                            </HtmlTooltip>
                          </Box>
                        </ClickAwayListener>
                      </Card>
                    </Grid>);
                  })}
                </Grid ></>);
          })}
          <Box
            sx={{ m: 1 }}
          ></Box>
          {isLoading && (
            <Stack direction={'row'} justifyContent={'center'} sx={{ mt: 2 }}>
              <CircularProgress />
            </Stack>
          )}
        </Container>
        {openTutorialVideo && <VideoTutorialModel
          key={`open-tutorial-video-model-${openTutorialVideo.id}`}
          onClose={onCloseTutorialVideo}
          toggle={togglenTutorialVideo}
          tutorialVideoItem={openTutorialVideo}
        />}
      </Page >
    </>
  );
};


export default VideoTutorial;
